<h2 mat-dialog-title>{{ isCreateMode ? 'Nueva numeración de documento' : 'Actualizar numeración de documento' }}</h2>
<form [formGroup]="updateAbbreviationForm" (ngSubmit)="updateTramiteAbreviacionHandler()">
    <mat-dialog-content>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Departamento</mat-label>
            <input type="text" matInput formControlName="codigoDepartamento" [matAutocomplete]="auto"
                (focus)="selectAllText($event)">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayDepartamentoFn">
                @for (option of departamentosFiltered | async; track option) {
                <mat-option [value]="option">
                    <div style="display: flex;flex-direction: column;">
                        <span>{{option.nombre}}</span>
                    </div>
                </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Numeración</mat-label>
            <input matInput formControlName="abreviacion" type="text">
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close>Cancelar</button>
        <button type="submit" mat-flat-button
            [disabled]="!updateAbbreviationForm.valid || fetchingUpdateTramiteAbreviacion">
            @if (fetchingUpdateTramiteAbreviacion) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else {
            <p>{{ isCreateMode ? 'Crear' : 'Actualizar' }}</p>
            }
        </button>
    </mat-dialog-actions>
</form>